import React from 'react';
import NavBar from '../pure/Navbar';

const ContainerNavBar = () => {
  return <NavBar />;
};

export default ContainerNavBar;
